import ModelsCarouselDesktop from '../../../../components/models-carousel/models-carousel.desktop';
import mfModelsCarousel from './mf-models-carousel';

export default mfModelsCarousel(ModelsCarouselDesktop);
